export const LOCALE = 'en';
export const { RAILS_ENV } = global.gon.env;

// Public keys.
export const { RECURLY_PUBLIC_API_KEY, SPLIT_IO_API_KEY } = global.gon.env;

// User
export const USER = global.gon.user;

//Store
export const STORE_CODE = global.gon.current_store.code;

// Pod constants.
export const MAX_POD_QUANTITY = 25;

// Strings.
export const COMPLIANCE_STATE_MESSAGE =
  'To comply with California and Washington state law, your billing and shipping must match. We’ve updated your shipping address for your convenience';
export const CHANGE_OUT_OF_COMPLIANCE_STATE_MESSAGE =
  'You are now able to edit your shipping address. For your convenience, we’ve updated it to match your new billing address.';

// Routing params.
// Names are succinct and generic to keep path helper invocations readable.
export const addressType = ':addressType';

// Address constants.
export const ADDRESS_TYPE_BILLING = 'billing';
export const ADDRESS_TYPE_SHIPPING = 'shipping';

// Subscription constants.
export const SUBSCRIPTION_STATUS_ACTIVE = 'active';
export const SUBSCRIPTION_STATUS_CANCELED = 'canceled';

// Base URLs.
export const SUPPORT_SITE_URL = gon.current_store.support_url;

// URLs
export const AUTOSHIP_URL = `/auto-ship`;
export const AGE_VERIFICATION_URL = `/account/age-verification`;
export const TRACKING_URL =
  'http://juulvapor.narvar.com/juulvapor/tracking/USPS?tracking_numbers=';

export const PENDING_POD_QUANTITY_UPDATE_DELAY = 500;

export const CHANGE_IN_MEMBERSHIP_URL_KEY = 'member-edit-blocked';
